






import { computed, defineComponent } from '@vue/composition-api';
import GiftBoxIcon from 'frontend/components/icons/GiftBoxIcon.vue';
import FlowersIcon from 'frontend/components/icons/FlowersIcon.vue';
import HeartIcon from 'frontend/components/icons/HeartIcon.vue';
import PartyPopperIcon from 'frontend/components/icons/PartyPopperIcon.vue';
import ClockIcon from 'frontend/components/icons/ClockIcon.vue';
import CoinIcon from 'frontend/components/icons/CoinIcon.vue';
import JournalIcon from 'frontend/components/icons/JournalIcon.vue';
import RocketIcon from 'frontend/components/icons/RocketIcon.vue';
import XIcon from 'frontend/components/icons/XIcon.vue';
import AppleIcon from 'frontend/components/icons/Apple.vue';
import CoffeeIcon from 'frontend/components/icons/CoffeeIcon.vue';
import TargetIcon from 'frontend/components/icons/TargetIcon.vue';
import SandwichIcon from 'frontend/components/icons/SandwichIcon.vue';
import GraphIcon from 'frontend/components/icons/GraphIcon.vue';
import PieSliceIcon from 'frontend/components/icons/PieSliceIcon.vue';

export default defineComponent({
  props: {
    iconComponent: String,
  },
  setup(props) {
    const icon = computed(() => {
      return props.iconComponent;
    });
    return {
      icon,
    };
  },
  components: {
    GiftBoxIcon,
    FlowersIcon,
    HeartIcon,
    PartyPopperIcon,
    ClockIcon,
    CoinIcon,
    JournalIcon,
    RocketIcon,
    XIcon,
    AppleIcon,
    CoffeeIcon,
    TargetIcon,
    SandwichIcon,
    GraphIcon,
    PieSliceIcon,
  },
});
